<template>
  <div class="invest-solution">
    <div class="invest-solution-container">
      <div class="invest-solution-row">
        <div class="invest-solution-col">
          <img
            class="rounded-lg-3 w-100"
            src="@/images/invest/invest-traffic-md.jpg"
          />
        </div>
        <div class="invest-solution-col">
          <h1 class="text-uppercase">
            <strong>OOYYO</strong> aggregates and analyzes
          </h1>
          <h1 class="text-uppercase">
            <strong>more than 10.000.000</strong><br />
            car listings <strong>worldwide</strong>
          </h1>
          <p>
            One of the <br />
            <span class="fw-bold text-uppercase">world’s largest</span><br />
            automotive repositories
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
